import Vue from 'vue'
import PrimeVue from 'primevue/config'
import InputSwitch from 'primevue/inputswitch'
import Calendar from 'primevue/calendar'
import ProgressBar from 'primevue/progressbar'
import 'primeicons/primeicons.css'

Vue.use(PrimeVue, {
  locale: {
    firstDayOfWeek: 1,
    dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    monthNames: [
      'januari',
      'februari',
      'maart',
      'april',
      'mei',
      'juni',
      'juli',
      'augustus',
      'september',
      'oktober',
      'november',
      'december'
    ],
    monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    today: 'Vandaag',
    clear: 'Wissen',
    dateFormat: 'dd-mm-yy',
    weekHeader: 'Wk'
  }
})
Vue.component('InputSwitch', InputSwitch)
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Calendar', Calendar)
Vue.component('ProgressBar', ProgressBar)
